import { useCallback, useContext } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { UNSAFE_NavigationContext } from 'react-router-dom'
import { closeModal, openModal, selectModalStack } from '../store/modalSlice'
import {
  createModalEntry,
  getModalHistoryIds,
  runAfterModalClose,
  withModalHistoryIds,
} from '../services/modalHistory'

function useModal() {
  const dispatch = useDispatch()
  const store = useStore()
  const navigationContext = useContext(UNSAFE_NavigationContext)
  const navigator = navigationContext?.navigator

  const handleOpenModal = useCallback(({ type, props }) => {
    const entry = createModalEntry(type, props)
    const location = navigator?.location
    if (!location) {
      dispatch(openModal(entry))
      return
    }
    const currentIds = getModalHistoryIds(location.state)
    dispatch(openModal(entry))
    navigator.push(
      { pathname: location.pathname, search: location.search, hash: location.hash },
      withModalHistoryIds(location.state, [...currentIds, entry.id]),
    )
  }, [dispatch, navigator])

  const handleCloseModal = useCallback((options) => {
    const location = navigator?.location
    if (!location) {
      dispatch(closeModal())
      if (typeof options?.afterClose === 'function') options.afterClose()
      return
    }
    const currentIds = getModalHistoryIds(location.state)
    const modalList = selectModalStack(store.getState())
    const topModal = modalList[modalList.length - 1]
    const afterClose = options?.afterClose

    if (currentIds.length > 0 && topModal?.id === currentIds[currentIds.length - 1]) {
      runAfterModalClose(topModal.id, afterClose)
      navigator.go(-1)
      return
    }

    dispatch(closeModal())
    if (typeof afterClose === 'function') afterClose()
  }, [dispatch, navigator, store])

  return { openModal: handleOpenModal, closeModal: handleCloseModal }
}

export default useModal
